import React, { useEffect, useState } from "react";
import MyContext from "../../../api/context/my-context";

const errorList = ({ errorList = [] }) => {
  return (
    <div>
      {errorList.map((m, index) => (
          <div>
            <div className="error-detail">
              <b>#{++index}</b> {"\u00A0"}
              {m}
            </div>
           <div/>
          </div>
      ))}
    </div>
  );
};

export default errorList;
